<section class="email-panel" aria-label="Enviar resumo da multa">
  <h2>Enviar resumo por e-mail</h2>
  <p class="email-panel__hint">
    Informe o e-mail do contrato ou da pessoa. O Flit Core envia o resumo da multa vinculada a esta placa.
  </p>

  <dl class="email-preview">
    <div><dt>Placa</dt><dd>{{ placa || '—' }}</dd></div>
    <div><dt>Nº AIT</dt><dd>{{ ait || '—' }}</dd></div>
    <div><dt>Contrato</dt><dd>{{ contrato || '—' }}</dd></div>
    <div><dt>Pessoa</dt><dd>{{ pessoa || '—' }}</dd></div>
    <div><dt>Vencimento</dt><dd>{{ vencimento || '—' }}</dd></div>
    <div><dt>Prazo para indicar o condutor</dt><dd>{{ prazoIndicacao || '—' }}</dd></div>
    <div><dt>Data da indicação do condutor</dt><dd>{{ dataIndicacao || '—' }}</dd></div>
    <div class="full"><dt>Descrição</dt><dd>{{ descricao || '—' }}</dd></div>
  </dl>

  <label class="form-label" for="multaEmailDestino">E-mail de destino</label>
  <div class="email-panel__row">
    <input
      id="multaEmailDestino"
      type="email"
      class="form-control"
      name="multaEmailDestino"
      [(ngModel)]="email"
      placeholder="nome@empresa.com"
      [disabled]="sending" />
    <button type="button" class="btn btn-primary" (click)="enviar()" [disabled]="sending || !emailValido">
      <span *ngIf="sending" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Enviar resumo
    </button>
  </div>

  <p *ngIf="error" class="alert alert-danger mt-3 mb-0">{{ error }}</p>
  <p *ngIf="success" class="alert alert-success mt-3 mb-0">{{ success }}</p>
</section>
